import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';

export const upload = createAsyncThunk("paymentUpload/upload", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/receive/payment/upload',val);
    return response.data;
});

export const getById = createAsyncThunk("paymentUpload/getById", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/receive/payment/upload/${id}`);
    return response.data;
});

export const getByTrxId = createAsyncThunk("paymentUpload/getByTrxId", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/receive/payment/upload/trxid/${id}`);
    return response.data;
});

export const approved = createAsyncThunk("paymentUpload/approved", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/payment/action/approved`,val);
    return response.data;
});

const initialState = {
    loading : false,
    response : {},
    single : {}
}

const paymentUploadSlice = createSlice({
    name:"paymentUploadSlice",
    initialState: initialState,
    extraReducers: {
        [upload.pending] : (state, action) => {
            state.loading = true;
        },
        [upload.fulfilled] : (state, action) => {
            state.response = action.payload;
            state.loading = false;
        },
        [upload.pending] : (state, action) => {
            state.loading = true;
        },


        [getById.pending] : (state, action) => {
            state.loading = true;
        },
        [getById.fulfilled] : (state, action) => {
            state.single = action.payload;
            state.loading = false;
        },
        [getById.pending] : (state, action) => {
            state.loading = true;
        },


        [getByTrxId.pending] : (state, action) => {
            state.loading = true;
        },
        [getByTrxId.fulfilled] : (state, action) => {
            state.single = action.payload;
            state.loading = false;
        },
        [getByTrxId.pending] : (state, action) => {
            state.loading = true;
        },

        [approved.pending] : (state, action) => {
            state.loading = true;
        },
        [approved.fulfilled] : (state, action) => {
            state.response = action.payload;
            state.loading = false;
        },
        [approved.pending] : (state, action) => {
            state.loading = true;
        },
    }
})

export const paymentUploadSelector = (state) => state.paymentUpload;
export default paymentUploadSlice.reducer;
